module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAENSURBVDhP7ZTJioNAEIZr5uCO4uOIiHjwqQU3XG76EB68qQcVN3TsojMJRJMcJpDDfCDVVMPHX6X4te3AG/im9c/5DPG6rvT0nJd2PI4jhGGIYsMwQBAEenPO08TLsqC0bVvoug6iKHop+UMxkcZxjFKWZUFRFJQ7joP1EaermKYJpXVdgyiKYJom9tM0haZpQJIk0DQN6xGHied5Bs/zUMDzPFiWBRzH4aPrOjAMg1MkSYJTHXEnvozf9z2OT14WEV0gZ9u2QZZlXIfrujAMA729cifOsgyqqsKkZPyjUYmcJFdVFeV5ntObG8iObynLcguCYNs/Mdo5Z0+6+b6/FUVBO1f+/xW/vEkM8APsydFw0xOCfgAAAABJRU5ErkJggsRGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointment/xsj_s.png
// module id = KVez
// module chunks = 1